import { render } from "./ArtistEditor.vue?vue&type=template&id=3ada1be5"
import script from "./ArtistEditor.vue?vue&type=script&lang=js"
export * from "./ArtistEditor.vue?vue&type=script&lang=js"
script.render = render

export default script